import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('UserFilter')
export class UserFilter extends Entity {
  @JsonProperty('keyword', [String])
  public keyword: string[] = [];
  @JsonProperty('status', [String])
  public status: string[] = [];
  @JsonProperty('role', [String])
  public role: string[] = [];
  @JsonProperty('serialNumber', [String])
  public serialNumber: string[] = [];
  @JsonProperty('accounts', Object)
  public accounts: Record<string, string> = {};
  @JsonProperty('orderBy', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
